const project = {
  name: '',
  dataGroups: {},
  userStories: {},
  userJourneys: {}
}

export default {
  project
}



// WEBPACK FOOTER //
// ./src/utils/templates.js